import styled from "styled-components";
import {useRouter} from "@/i18n/navigation";
import {SIZES} from "@/components/constants";

const FloatButton = ({data}) => {
    const router = useRouter();
    return(
        <FloatButtonWrap onClick={() => {router.push("/help-center")}}><img src={data["contact-img"]} alt={"문의하기 버튼"} /> </FloatButtonWrap>
    )
}
const FloatButtonWrap = styled.div`
    position: fixed;
    width: 85px;
    height: 85px;
    right: 5.33%;
    bottom: 11.56%;
    z-index: 2;
    cursor: pointer;
    @media screen and (max-width: ${SIZES.TABLET_L}) {
        width: 70px;
        height: 70px;
    }
    @media screen and (max-width: ${SIZES.MOBILE_L}) {
        width: 52px;
        height: 52px;
    }
`
export default FloatButton;